var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "performance-report-detail" },
    [
      _c("div", { staticClass: "header" }, [_vm._v("履约报表详情")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("div", { staticClass: "detail basic-msg" }, [
            _c("div", { staticClass: "header" }, [_vm._v("基础信息")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content" },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      "tooltip-effect": "dark",
                      border: "",
                      data: _vm.resData.list
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "str_demanded_date",
                        label: "需求日期"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "supply_id",
                        label: "商家ID"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "str_supply",
                        label: "商家",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "str_market",
                        label: "市场",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "str_pg_group",
                        label: "代采组",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "str_pg_member",
                        label: "代采员"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeTab,
                callback: function($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab"
              }
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "履约总览", name: "sumUp" } },
                [
                  _c("div", { staticClass: "detail amount" }, [
                    _c("div", { staticClass: "header" }, [
                      _c("span", { staticStyle: { color: "#4e9fe8" } }, [
                        _vm._v(
                          "\n              （数量/金额，金额按计划代采单统计）\n            "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "tooltip-effect": "dark",
                              border: "",
                              data: _vm.resData.list
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "24h_performance_rate",
                                label: "24H履约率"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "header",
                                  fn: function() {
                                    return [
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            placement: "top"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                position: "relative"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      24H履约率"
                                              ),
                                              _c("i", {
                                                staticClass: "el-icon-question"
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content"
                                            },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  "\n                        统计需求日期当天（截止至晚上24点）已履约的金额占比\n                      "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("div", [
                                                _vm._v(
                                                  "24H履约率 = 24H已履约金额 / 总需求金额"
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  },
                                  proxy: true
                                },
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("div", [
                                        _c("div", [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                scope.row[
                                                  "24h_performance_rate"
                                                ]
                                              ) +
                                              "\n                    "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticStyle: { color: "#ccc" } },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  scope.row[
                                                    "24h_generate_status"
                                                  ]
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "48h_performance_rate",
                                label: "48H履约率"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "header",
                                  fn: function() {
                                    return [
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            placement: "top"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                position: "relative"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      48H履约率"
                                              ),
                                              _c("i", {
                                                staticClass: "el-icon-question"
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content"
                                            },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  "\n                        统计需求日期次日（截止至晚上24点）已履约的金额占比\n                      "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("div", [
                                                _vm._v(
                                                  "48H履约率 = 48H已履约金额 / 总需求金额"
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  },
                                  proxy: true
                                },
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("div", [
                                        _c("div", [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                scope.row[
                                                  "48h_performance_rate"
                                                ]
                                              ) +
                                              "\n                    "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticStyle: { color: "#ccc" } },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  scope.row[
                                                    "48h_generate_status"
                                                  ]
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "360h_performance_rate",
                                label: "360H履约率"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "header",
                                  fn: function() {
                                    return [
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            placement: "top"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                position: "relative"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      360H履约率"
                                              ),
                                              _c("i", {
                                                staticClass: "el-icon-question"
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content"
                                            },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  "\n                        统计需求日期15天内（截止至晚上24点）已履约的金额占比\n                      "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("div", [
                                                _vm._v(
                                                  "360H履约率 = 360H已履约金额 / 总需求金额"
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  },
                                  proxy: true
                                },
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("div", [
                                        _c("div", [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                scope.row[
                                                  "360h_performance_rate"
                                                ]
                                              ) +
                                              "\n                    "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticStyle: { color: "#ccc" } },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  scope.row[
                                                    "360h_generate_status"
                                                  ]
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "final_performance_rate",
                                label: "总履约率"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "header",
                                  fn: function() {
                                    return [
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            placement: "top"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                position: "relative"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      总履约率"
                                              ),
                                              _c("i", {
                                                staticClass: "el-icon-question"
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content"
                                            },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  "统计截止当前所有已履约的金额占比"
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("div", [
                                                _vm._v(
                                                  "总履约率 = 总已履约金额 / 总需求金额"
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "delivery_accuracy",
                                label: "货期准确率"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "header",
                                  fn: function() {
                                    return [
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            placement: "top"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                position: "relative"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      货期准确率"
                                              ),
                                              _c("i", {
                                                staticClass: "el-icon-question"
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content"
                                            },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  "统计商品到达承诺货期是所履约的金额占比"
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("div", [
                                                _vm._v(
                                                  "\n                        货期准确率=货期到期时已履约金额/订货单总需求金额*100%\n                      "
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  },
                                  proxy: true
                                },
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("div", [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              scope.row["delivery_accuracy"]
                                            ) +
                                            "\n                  "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "small"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.handleDeliveryAccuracyClick(
                                                scope.row
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    查看明细\n                  "
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c(
                              "el-table-column",
                              { attrs: { align: "center", label: "总需求" } },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "str_all_pre",
                                    label: "前置仓发货"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "header",
                                      fn: function() {
                                        return [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                placement: "top"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    position: "relative"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        前置仓发货"
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        统计前一天6:00至当天6:00由前置仓发货的商品，包含发货出库、售后寄出和前置仓异常出库（即前置仓买赔）\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    },
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var row = ref.row
                                        return [
                                          _c("div", [
                                            _c("div", [
                                              _vm._v(_vm._s(row.pre_num))
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(_vm._s(row.pre_price))
                                            ])
                                          ])
                                        ]
                                      }
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    width: "100",
                                    prop: "str_all_inventory",
                                    label: "现货发货"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "header",
                                      fn: function() {
                                        return [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                placement: "top"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    position: "relative"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        现货发货"
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        统计前一天6:00至当天6:00由现货发货的商品，包含发货出库、售后寄出。\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "str_all_plan",
                                    label: "订货单计划代采"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "header",
                                      fn: function() {
                                        return [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                placement: "top"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    position: "relative"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        订货单计划代采"
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        统计对应需求时间的代采计划中，总计划代采的商品数据。不含提前代采计划\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    },
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var row = ref.row
                                        return [
                                          _c("div", [
                                            _c("div", [
                                              _vm._v(_vm._s(row.plan_num) + "/")
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(_vm._s(row.plan_price))
                                            ])
                                          ])
                                        ]
                                      }
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "str_all_sum",
                                    label: "小计"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "header",
                                      fn: function() {
                                        return [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                placement: "top"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    position: "relative"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        小计"
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        总需求 = 前置仓发货 + 订货单计划代采\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    },
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var row = ref.row
                                        return [
                                          _c("div", [
                                            _c("div", [
                                              _vm._v(_vm._s(row.sum_num) + "/")
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(_vm._s(row.sum_price))
                                            ])
                                          ])
                                        ]
                                      }
                                    }
                                  ])
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-table-column",
                              { attrs: { align: "center", label: "已履约" } },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "str_done_pre",
                                    label: "前置仓发货"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "header",
                                      fn: function() {
                                        return [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                placement: "top"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    position: "relative"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        前置仓发货"
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        统计前一天6:00至当天6:00由前置仓发货的商品，包含发货出库、售后寄出和前置仓异常出库（即前置仓买赔）\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    },
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var row = ref.row
                                        return [
                                          _c("div", [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(row.done_pre_num) + "/"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(_vm._s(row.done_pre_price))
                                            ])
                                          ])
                                        ]
                                      }
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    width: "100",
                                    prop: "str_done_inventory",
                                    label: "现货发货"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "header",
                                      fn: function() {
                                        return [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                placement: "top"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    position: "relative"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        现货发货"
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        统计前一天6:00至当天6:00由现货发货的商品，包含发货出库、售后寄出。\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "str_done_plan",
                                    label: "订货单正常品已入库（含坏账）"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "header",
                                      fn: function() {
                                        return [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                placement: "top"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    position: "relative"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        订货单正常品已入库（含坏账）"
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        统计对应需求时间的代采计划，开单后售前首次以正常品入库\n                        或 首次申请为坏账时计入。\n                        ①恢复欠货/正常品入库后调拨为不良品/坏账驳回均不再扣除。\n                        ②已计入履约的，不再重复计算。\n                        ③履约时间：代采欠货正常品入库-取生成包裹时间（快递包裹取揽收时间，无揽收时间时取仓库接收时间；无揽收时间且无接收时间时取最早的点货批次创建时间）；退换货欠货正常品入库\n                        - 取入库时间；申请坏账 - 申请坏账时间。\n                        ④入库来源=【代采欠货、退换货欠货、其它入库（退换货）】的退换区的商品被加入「商品盘亏表」时，消除「待履约」里的“退换货”，同时在“订货单正常品入库（含坏账）”里增加相应件数及金额。\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    },
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var row = ref.row
                                        return [
                                          _c("div", [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(row.done_plan_num) + "/"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(row.done_plan_price)
                                              )
                                            ])
                                          ])
                                        ]
                                      }
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "str_done_sum",
                                    label: "小计"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "header",
                                      fn: function() {
                                        return [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                placement: "top"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    position: "relative"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        小计"
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        已履约 = 前置仓发货+现货发货 +\n                        订货单正常品已入库（含坏账）\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    },
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var row = ref.row
                                        return [
                                          _c("div", [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(row.final_num) + "/"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(_vm._s(row.final_price))
                                            ])
                                          ])
                                        ]
                                      }
                                    }
                                  ])
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-table-column",
                              { attrs: { align: "center", label: "待履约" } },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "str_doing_plan",
                                    label: "待开单"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "header",
                                      fn: function() {
                                        return [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                placement: "top"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    position: "relative"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        待开单"
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        统计对应需求时间的代采计划当前在待开单的商品数据。\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    },
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var row = ref.row
                                        return [
                                          _c("div", [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(row.doing_plan_num) + "/"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(row.doing_plan_price)
                                              )
                                            ])
                                          ])
                                        ]
                                      }
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "str_doing_owe",
                                    label: "订单欠货"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "header",
                                      fn: function() {
                                        return [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                placement: "top"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    position: "relative"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        订单欠货"
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        统计对应需求时间的代采计划当前在订单欠货（含由订单欠货转退款中）的商品数据。\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    },
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var row = ref.row
                                        return [
                                          _c("div", [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(row.doing_owe_num) + "/"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(row.doing_owe_price)
                                              )
                                            ])
                                          ])
                                        ]
                                      }
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "str_doing_on_way",
                                    label: "配送在途"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "header",
                                      fn: function() {
                                        return [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                placement: "top"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    position: "relative"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        配送在途"
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        统计对应需求时间的代采计划当前在配送在途（即在途库存）、在途转欠货申请中的商品数据。\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    },
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var row = ref.row
                                        return [
                                          _c("div", [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(row.doing_on_way_num) +
                                                  "/"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(row.doing_on_way_price)
                                              )
                                            ])
                                          ])
                                        ]
                                      }
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "str_doing_reject",
                                    label: "退换货"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "header",
                                      fn: function() {
                                        return [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                placement: "top"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    position: "relative"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        退换货"
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        统计对应需求时间的代采计划当前为售前不良品在库、退换货待接收、退换货欠货、由售前退换货转退款中和转呆账的商品数据。\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    },
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var row = ref.row
                                        return [
                                          _c("div", [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(row.doing_reject_num) +
                                                  "/"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(row.doing_reject_price)
                                              )
                                            ])
                                          ])
                                        ]
                                      }
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "str_doing_sum",
                                    label: "小计"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "header",
                                      fn: function() {
                                        return [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                placement: "top"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    position: "relative"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        小计"
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        待履约 = 待开单 + 订单欠货 + 配送在途 + 退换货\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    },
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var row = ref.row
                                        return [
                                          _c("div", [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(row.sum_doing_num) + "/"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(row.sum_doing_price)
                                              )
                                            ])
                                          ])
                                        ]
                                      }
                                    }
                                  ])
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-table-column",
                              { attrs: { align: "center", label: "未履约" } },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "str_yet_stopped",
                                    label: "已断货"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "header",
                                      fn: function() {
                                        return [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                placement: "top"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    position: "relative"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        已断货"
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        统计对应需求时间的代采计划当前已断货的商品数据。\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    },
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var row = ref.row
                                        return [
                                          _c("div", [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(row.yet_stopped_num) +
                                                  "/"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(row.yet_stopped_price)
                                              )
                                            ])
                                          ])
                                        ]
                                      }
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "str_yet_ded",
                                    label: "转抵扣"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "header",
                                      fn: function() {
                                        return [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                placement: "top"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    position: "relative"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        转抵扣"
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        统计对应需求时间的代采计划当前已转抵扣（含待抵扣、已抵扣、待抵扣转退款中）的商品数据。\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    },
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var row = ref.row
                                        return [
                                          _c("div", [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(row.yet_ded_num) + "/"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(_vm._s(row.yet_ded_price))
                                            ])
                                          ])
                                        ]
                                      }
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "str_yet_refund",
                                    label: "已退款"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "header",
                                      fn: function() {
                                        return [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                placement: "top"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    position: "relative"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        已退款"
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        统计对应需求时间的代采计划当前已完成退款的商品数据。\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    },
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var row = ref.row
                                        return [
                                          _c("div", [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(row.yet_refund_num) + "/"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(row.yet_refund_price)
                                              )
                                            ])
                                          ])
                                        ]
                                      }
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "str_yet_cpin",
                                    label: "次品入库"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "header",
                                      fn: function() {
                                        return [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                placement: "top"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    position: "relative"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        次品入库"
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        统计对应需求时间的代采计划商品，因开单后售前首次以次品入库或退换货欠货首次以次品入库，均计入“次品入库”里；\n                        注意：恢复欠货并通过审核后，因商品重新回到代采欠货/在途库存，需要消掉对于的“次品入库”数据，并将数据返回到相应的表头记录里。\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "str_yet_sum",
                                    label: "小计"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "header",
                                      fn: function() {
                                        return [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                placement: "top"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    position: "relative"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        小计"
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        未履约 = 已断货 + 转抵扣 + 已退款\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    },
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var row = ref.row
                                        return [
                                          _c("div", [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(row.sum_yet_num) + "/"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(_vm._s(row.sum_yet_price))
                                            ])
                                          ])
                                        ]
                                      }
                                    }
                                  ])
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-table-column",
                              { attrs: { align: "center", label: "不考核" } },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    width: "100",
                                    prop: "not_evaluate_inventory_num",
                                    label: "现货发货"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "header",
                                      fn: function() {
                                        return [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                placement: "top"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    position: "relative"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        现货发货"
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        统计前一天6:00至当天6:00由现货发货的商品，包含发货出库、售后寄出。\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    },
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var row = ref.row
                                        return [
                                          _c("div", [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  row.not_evaluate_inventory_num
                                                ) + "/"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  row.not_evaluate_inventory_price
                                                )
                                              )
                                            ])
                                          ])
                                        ]
                                      }
                                    }
                                  ])
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "商品履约", name: "fulfillment" } },
                [
                  _c("div", { staticClass: "detail amount" }, [
                    _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _c("YsDataTable", {
                          ref: "tableFulfillmentRef",
                          attrs: {
                            "init-params": _vm.initParamsFulfillment,
                            list: _vm.searchListFulfillment,
                            columns: _vm.columnsFulfillment,
                            "fetch-method": _vm.fetchMethodFulfillment,
                            "page-size-alias": "page_size",
                            "page-sizes": [5, 10, 20, 30, 50, 100],
                            "page-size": 5,
                            "button-list": _vm.buttonListFulfillment,
                            "use-data-field": "",
                            "max-height": "580"
                          },
                          on: {
                            "on-page-change": _vm.handlePageChange,
                            "on-change": _vm.getSearchFulfillmentParams
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "goods_img",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "goods-img",
                                      on: {
                                        click: function($event) {
                                          return _vm.handleViewImages([
                                            row.main_img
                                          ])
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          "max-width": "100%",
                                          "max-height": "100%",
                                          "object-fit": "cover"
                                        },
                                        attrs: { src: row.main_img }
                                      })
                                    ]
                                  )
                                ]
                              }
                            },
                            {
                              key: "delivery_accuracy",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleSkuDetailsClick(row)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(row.delivery_accuracy) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ]
                              }
                            },
                            {
                              key: "not_evaluate_inventory_num",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _c("div", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(row.not_evaluate_inventory_num) +
                                        " /\n                  " +
                                        _vm._s(
                                          row.not_evaluate_inventory_price
                                        ) +
                                        "\n                "
                                    )
                                  ])
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.refreshFulfillment,
                            callback: function($$v) {
                              _vm.refreshFulfillment = $$v
                            },
                            expression: "refreshFulfillment"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("el-collapse-transition", [
            _c("div", { staticClass: "detail amount" }, [
              _c(
                "div",
                {
                  staticClass: "header",
                  staticStyle: { cursor: "pointer" },
                  on: {
                    click: function($event) {
                      _vm.goodsDetailShow = !_vm.goodsDetailShow
                    }
                  }
                },
                [
                  _vm._v("\n          商品明细\n          "),
                  _c("el-button", {
                    staticStyle: { "margin-left": "8px", "font-size": "22px" },
                    attrs: {
                      icon: _vm.goodsDetailShow
                        ? "el-icon-arrow-up"
                        : "el-icon-arrow-down",
                      type: "text"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.goodsDetailShow,
                      expression: "goodsDetailShow"
                    }
                  ],
                  staticClass: "content"
                },
                [
                  _c(
                    "el-tabs",
                    {
                      attrs: { stretch: true },
                      on: { "tab-click": _vm.handleClickTag },
                      model: {
                        value: _vm.activeName,
                        callback: function($$v) {
                          _vm.activeName = $$v
                        },
                        expression: "activeName"
                      }
                    },
                    _vm._l(_vm.resData.options_report_detail_type, function(
                      item
                    ) {
                      return _c("el-tab-pane", {
                        key: item.value,
                        attrs: { label: item.label, name: item.value }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("YsDataTable", {
                    ref: "tableRef",
                    attrs: {
                      "init-params": _vm.initParams,
                      list: _vm.searchList,
                      "dep-option-map": _vm.optionsMap,
                      columns: _vm.columns,
                      "fetch-method": _vm.fetchMethod,
                      "page-size-alias": "page_size",
                      "button-list": _vm.buttonList,
                      "use-data-field": ""
                    },
                    on: {
                      "on-change": _vm.getSearchParams,
                      "on-fetch-success": _vm.handleFetchSuccess
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "table-title",
                        fn: function() {
                          return [
                            _c("div", { staticClass: "header" }, [
                              _vm._v(
                                "\n                数据列表 共" +
                                  _vm._s(_vm.goodsDetailAmount.sum_num) +
                                  "件，计￥" +
                                  _vm._s(_vm.goodsDetailAmount.sum_price) +
                                  "元\n              "
                              )
                            ])
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "goods_img",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "goods-img",
                                on: {
                                  click: function($event) {
                                    return _vm.handleViewImages([row.goods_img])
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  staticStyle: {
                                    "max-width": "100%",
                                    "max-height": "100%",
                                    "object-fit": "cover"
                                  },
                                  attrs: { src: row.goods_img }
                                })
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "wcgPlan",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c("div", { staticClass: "wcg-plan" }, [
                              _c("span", { staticClass: "wcg_plan_id" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(row.planid) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "ptype" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(row.ptype) +
                                    "\n                  "
                                ),
                                row.is_dispense
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "#479ce8" } },
                                      [
                                        _vm._v(
                                          "\n                    （ 小店分发）\n                  "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "effect-time" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(row.effect_time) +
                                    "\n                "
                                )
                              ])
                            ])
                          ]
                        }
                      },
                      {
                        key: "wcgOrder",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c("div", { staticClass: "wcg-plan" }, [
                              _c("span", { staticClass: "woid" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(row.woid) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "wcg-sub-time" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(row.wcg_sub_time) +
                                    "\n                "
                                )
                              ])
                            ])
                          ]
                        }
                      },
                      {
                        key: "procurementOrderSubmissionTime",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c("div", { staticClass: "wcg-plan" }, [
                              _c("span", { staticClass: "woid" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(row.woid) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "wcg-sub-datetime" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(row.wcg_sub_datetime) +
                                    "\n                "
                                )
                              ])
                            ])
                          ]
                        }
                      },
                      {
                        key: "performance_time",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c("div", { staticClass: "wcg-plan" }, [
                              _c("span", { staticClass: "woid" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(row.woid) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "wcg-sub-time" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(row.wcg_sub_time) +
                                    "\n                "
                                )
                              ])
                            ])
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.refresh,
                      callback: function($$v) {
                        _vm.refresh = $$v
                      },
                      expression: "refresh"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.detailsDialog,
            "append-to-body": "",
            title:
              _vm.detailsData.type === 1
                ? "货期准确率明细"
                : "商品货期准确率明细"
          },
          on: {
            "update:visible": function($event) {
              _vm.detailsDialog = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "padding-bottom": "20px", "font-size": "16px" } },
            [
              _c("span", [
                _vm._v(
                  "需求日期：" +
                    _vm._s(
                      _vm.detailsData.detail.demanded_date ||
                        _vm.detailsData.detail.str_demanded_date
                    )
                )
              ]),
              _vm._v(" "),
              _c("span", { staticStyle: { "margin-left": "100px" } }, [
                _vm._v("商家：" + _vm._s(_vm.detailsData.detail.supply_name))
              ])
            ]
          ),
          _vm._v(" "),
          _vm.detailsData.type === 2 && _vm.detailsData.detail
            ? _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "padding-bottom": "20px",
                    "padding-top": "20px"
                  }
                },
                [
                  _c("img", {
                    staticClass: "goods-img",
                    staticStyle: {
                      width: "100px",
                      height: "100px",
                      "object-fit": "cover",
                      "flex-shrink": "0",
                      "margin-right": "20px"
                    },
                    attrs: { src: _vm.detailsData.detail.main_img },
                    on: {
                      click: function($event) {
                        return _vm.handleViewImages([
                          _vm.detailsData.detail.main_img
                        ])
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "line-height": "35px" } }, [
                    _c("div", [
                      _vm._v(_vm._s(_vm.detailsData.detail.goods_name))
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n          款号：" +
                          _vm._s(_vm.detailsData.detail.goods_kh) +
                          "\n          "
                      ),
                      _c("span", { staticStyle: { "padding-left": "10px" } }, [
                        _vm._v("货号：")
                      ]),
                      _vm._v(
                        _vm._s(_vm.detailsData.detail.goods_no) + "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n          颜色：" +
                          _vm._s(_vm.detailsData.detail.si_val) +
                          "\n          "
                      ),
                      _c("span", { staticStyle: { "padding-left": "10px" } }, [
                        _vm._v("尺码：")
                      ]),
                      _vm._v(
                        _vm._s(_vm.detailsData.detail.co_val) + "\n        "
                      )
                    ])
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.detailsLoading,
                  expression: "detailsLoading"
                }
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                border: "",
                data: _vm.detailsData.list,
                "show-summary": "",
                "summary-method": _vm.detailsSummaryResults
              }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "delivery_day", label: "货期", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "delivery_time",
                  label: "承诺发货日期",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "total_plan_price",
                  label: "需求金额",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "plan_price_rate",
                  label: "需求金额占比",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "delivery_plan_price",
                  label: "货期内已履约金额",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "delivery_accuracy",
                  label: "货期准确率",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "delivery_generate_status",
                  label: "统计状态",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function() {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { position: "relative" } },
                              [
                                _vm._v("\n              统计状态"),
                                _c("i", { staticClass: "el-icon-question" })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c("div", [
                                  _vm._v("当前时间超过承诺发货日期时")
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v("统计状态为“已生成”，否则为“统计中")
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09377c56", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09377c56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PerformanceReport/PerformanceReportDetail.vue
// module id = null
// module chunks = 